import { TrackingCategory } from '@bridebook/web/app-basic/lib/analytics/tracking-category';
import { TrackingEvent } from '@bridebook/web/app-basic/lib/analytics/tracking-event';
import { ThunkAction } from '@bridebook/web/app-basic/lib/types';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { Slug } from '@bridebook/toolbox/src/types';
import { TLoggedOutPageClickedSection } from '@bridebook/web/app-shared/lib/types';

export interface IClickedOnLoggedOutPage {
  category?: string;
  clickedLocation?: string;
  clickedSection?: TLoggedOutPageClickedSection;
  cta?: string;
  supplierCategory?: Slug;
  supplierCountryCode?: CountryCodes;
  supplierCountryName?: string;
  supplierId?: ISupplier['id'];
  supplierName?: ISupplier['name'];
  supplierTier?: number;
  noteToCouple?: boolean;
  trackingTarget?: 'BigQuery';
}

//Clicked on logged out page
export const clickedOnLoggedOutPage: (payload: IClickedOnLoggedOutPage) => ThunkAction<void> =
  (payload: IClickedOnLoggedOutPage): ThunkAction<void> =>
  (_, __, { analyticsService }) => {
    const url = document.URL;

    analyticsService.getMethods(TrackingCategory.LoggedOut).track({
      event: TrackingEvent.ClickedOnLoggedOutPage,
      ...payload,
      url,
    });
  };
